import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import { Box, Paper, IconButton, TextField, MenuItem, Select, Chip, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { PERMISSIONS } from "routes/permissionsCode";
import { hasPermission } from "store1/user login data/user.login.data.slice.slector";
import DeleteIcon from "@mui/icons-material/Delete";
import { Edit } from "@mui/icons-material";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import { useDispatch, useSelector } from "react-redux";

import CustomizedDialogs from "../MuiReusableComponents/MuiPopupDialog/pop-up-withoutAppBar";
import PopupDialogs from "../MuiReusableComponents/MuiPopupDialog/new-popup";
import MyButton from "../MuiReusableComponents/MuiButton/buttonMUI";
import {
  startDeleteLeave,
  startSingleLeaveData,
  allLeaveDataCountSelector,
  startUpdateLeaveStatus
} from "../../store1/leaves data/leavesData.Slice.Selector";
import { readStringDate } from "../../function utils/functionUtils";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { usersDataSelector } from "../../store1/user login data/user.login.data.slice.slector";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  if (!array || !Array.isArray(array)) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, headCells } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow size="small">
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            size="small"
            sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
            align="left"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const DeleteButton = ({ handleClickOpen, formDefaultData }) => {
  const canCancelLeave = useSelector((state) => hasPermission(state, PERMISSIONS.HR.LEAVE.CANCEL));
  return (
    <IconButton
      disabled={!canCancelLeave}
      title="Delete"
      aria-label="delete"
      onClick={() => {
        handleClickOpen();
      }}
    >
      <DeleteIcon />
    </IconButton>
  );
};

///////Component Needed
const ConfirmMessage = ({ formDefaultData, setPopUpBool }) => {
  const { row } = formDefaultData;

  const dispacth = useDispatch();
  return (
    <>
      <Box sx={{ padding: "10px 5px" }}>
        <Typography>Do you want to delete this record ?</Typography>
      </Box>
      <Box sx={{ p: "10px 0 0 0" }}>
        <MyButton
          size="small"
          onClick={() => {
            dispacth(startDeleteLeave(row.id));
            setPopUpBool(false);
          }}
          variant="contained"
        >
          Yes{""}
        </MyButton>
        <MyButton
          size="small"
          sx={{ marginLeft: "20px" }}
          onClick={() => {
            setPopUpBool(false);
          }}
        >
          No
        </MyButton>
      </Box>
    </>
  );
};

export default function AdminTableSortingAndSelect({ headCells, rows, currentPageIndex }) {
  const userLoginData = useSelector(usersDataSelector);
  const totalLeave = useSelector(allLeaveDataCountSelector);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("employeeId");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const hasAdminPermission = useSelector((state) => hasPermission(state, PERMISSIONS.HR.LEAVE.ADMIN_APPLY));
  const hasLeaveApprovePermission = useSelector((state) => hasPermission(state, PERMISSIONS.HR.LEAVE.APPROVE));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const locationName = location.pathname || '';
  const search = new URLSearchParams(location.search);

  React.useEffect(() => {
    const pageFromUrl = currentPageIndex - 1;
    setPage(pageFromUrl);
  }, [currentPageIndex]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const pageIndex = newPage + 1;
    const PAGE_SIZE = 10;
    const newSearch = new URLSearchParams(location.search);
    newSearch.set('pageIndex', pageIndex);
    newSearch.set('pageSize', PAGE_SIZE);
    navigate(`${locationName}?${newSearch.toString()}`);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);

    const newSearch = new URLSearchParams(location.search);
    newSearch.set('pageIndex', '1');
    newSearch.set('pageSize', '10');
    navigate(`${locationName}?${newSearch.toString()}`);
  };

  const [openStatusPopup, setOpenStatusPopup] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [selectedStatus, setSelectedStatus] = React.useState("");
  const [remarks, setRemarks] = React.useState("");

  const submitHandler = (data) => {
    if (!selectedRow) {
      return;
    }

    const payload = {
      approval_status: selectedStatus,
      status_remarks: remarks,
    };

    const pageIndex = page + 1;
    const PAGE_SIZE = 10;

    dispatch(startUpdateLeaveStatus({
      id: selectedRow.id,
      payload,
      pageSize: PAGE_SIZE,
      pageIndex
    }));
    setOpenStatusPopup(false);
  };

  const UpdateStatusPopup = () => (
    <PopupDialogs
      title="Update Leave Status"
      size="sm"
      open={openStatusPopup}
      setOpen={setOpenStatusPopup}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box>
          <Typography>Status</Typography>
          <Select
            fullWidth
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            <MenuItem value={1}>Approve</MenuItem>
            <MenuItem value={2}>Reject</MenuItem>
          </Select>
        </Box>

        <Box>
          <Typography>Remarks</Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Enter status remarks"
          />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <MyButton variant="outlined" onClick={() => setOpenStatusPopup(false)}>
            Cancel
          </MyButton>
          <MyButton variant="contained" onClick={submitHandler} disabled={!selectedStatus}>
            Update
          </MyButton>
        </Box>
      </Box>
    </PopupDialogs>
  );

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ mb: 2, padding: "10px", width: "100%" }}>
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size="medium"
          >
            <EnhancedTableHead
              headCells={headCells}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                ?.map((row, idx) => {
                  const serialNumber = (currentPageIndex - 1) * rowsPerPage + idx + 1;
                  return (
                    <TableRow hover key={idx}>
                      {headCells.map((head, idxHead) => {
                        if (head.id === "id") {
                          return (
                            <TableCell
                              key={`${idx}${idxHead}`}
                              size="small"
                              align="left"
                              sx={{ width: '50px' }}
                            >
                              {serialNumber}
                            </TableCell>
                          );
                        }
                        if (head.id === "to_date" || head.id === "from_date") {
                          return (
                            <TableCell
                              key={`${idx}${idxHead}`}
                              size="small"
                              align="left"
                            >
                              {`${readStringDate(row[head.id])}`}
                            </TableCell>
                          );
                        }
                        // if (head.id === "update_status") {
                        //   return (
                        //     <TableCell
                        //       size="small"
                        //       key={`${idx}${idxHead}`}
                        //       sx={{ width: "150px" }}
                        //     >
                        //       <Box sx={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                        //         <Button
                        //           variant="contained"
                        //           size="small"
                        //           startIcon={<HowToRegIcon />}
                        //           disabled={row.approval_status != 0}
                        //           onClick={() => {
                        //             setSelectedRow(row);
                        //             setSelectedStatus(row?.approval_status ?? "");
                        //             setRemarks(row?.status_remarks ?? "");
                        //             setOpenStatusPopup(true);
                        //           }}
                        //         >
                        //           {row.approval_status == 0 ? "Update" : "Updated"}
                        //         </Button>
                        //       </Box>
                        //     </TableCell>
                        //   );
                        // }
                        if (head.id === "action") {
                          return (
                            <TableCell
                              size="small"
                              key={`${idx}${idxHead}`}
                              sx={{ width: "100px" }}
                            >
                              <Box sx={{ display: "flex" }}>
                                <IconButton
                                  title="View more details"
                                  size="small"
                                  onClick={() => {
                                    dispatch(startSingleLeaveData(row.id));
                                    navigate(`${locationName}/${row.id}/view-leave`);
                                  }}
                                >
                                  <VisibilityIcon color="primary" />
                                </IconButton>

                                {row.approval_status == 0 && hasAdminPermission && hasLeaveApprovePermission && (
                                  <IconButton
                                    title="Edit"
                                    size="small"
                                    onClick={() => {
                                      dispatch(startSingleLeaveData(row.id));
                                      navigate(`${locationName}/${row.id}/edit`);
                                    }}
                                  >
                                    <Edit color="primary" />
                                  </IconButton>
                                )}

                                {row.approval_status == 0 && (
                                  <CustomizedDialogs
                                    maxWidth="xs"
                                    DialogContentForm={ConfirmMessage}
                                    topic={"Confirm"}
                                    ButtonForFormDialog={DeleteButton}
                                    formDefaultData={{ row }}
                                  />
                                )}
                              </Box>
                            </TableCell>
                          );
                        }
                        if (head.id === "approval_status") {
                          return (
                            <TableCell
                              key={`${idx}${idxHead}`}
                              size="small"
                              align="left"
                            >
                              <Chip
                                variant="outlined"
                                label={row.approval_status == 0 ? "Pending" : row.approval_status == 1 ? 'Approved' : "Rejected"}
                                color={row.approval_status == 0 ? "secondary" : row.approval_status == 1 ? 'success' : "error"}
                              />
                            </TableCell>
                          );
                        }
                        return (
                          <TableCell
                            size="small"
                            key={`${idx}${idxHead}`}
                            align="left"
                          >
                            {row[head.id]}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        {rows && rows.length === 0 ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 2 }}>
            <Typography variant="h5">
              {userLoginData.empId === null ? '' : 'No Data Found'}
            </Typography>
          </Box>
        ) : (
          <TablePagination
            rowsPerPageOptions={[10, 25, 35]}
            component="div"
            count={totalLeave}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </Paper>
      {UpdateStatusPopup()}
    </Box>
  );
}